import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { assert } from '@sama/js-core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'h3-auto-save-fail-modal',
  templateUrl: './auto-save-fail-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AutoSaveFailModalComponent {
  @Input() retryFn?: () => Promise<void>;
  draftSavePeriod = environment.draftSavePeriod / 1000;
  isSaving$ = new BehaviorSubject(false);

  constructor(private dialogRef: MatDialogRef<AutoSaveFailModalComponent>) {}

  async retry() {
    assert(
      this.retryFn,
      'it should not be possible to click retry without a retry function',
    );
    this.isSaving$.next(true);
    try {
      await this.retryFn();
      this.dialogRef.close();
    } catch {
      this.isSaving$.next(false);
    }
  }
}
